import "antd/dist/antd.css";
import "../../../assests/style.css";
import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { initialState, reducer } from "./reducer";
import { setRowNumber } from "../../../../helpers/MainHelper.js";
import { useSelector } from "react-redux";
import DataCounterCard from "../../../../components/Common/Cards/DataCounterCard.js";
import EmigrantService from "../../../../services/Election/EmigrantService";
import SimpleHeader from "../../../../helpers/cards-helper/SimpleHeader";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";
import Search from "./components/Search";
import List from "./components/List.js";
import Add from "./components/Add.js";
import Edit from "./components/Edit.js";



const Emigrants = () => {
    const token = useSelector((state) => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [countries, setCountries] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);


    useEffect(() => {
        const fetchEmigrants = async () => {
            updateLoading(true);
            try {
                const response = await EmigrantService.getList(token, state.filters);
                const apiResponse = response.data;
                updateItems(apiResponse?.data, apiResponse?.count);
                setErrorMessage(null);
            } catch (error) {
                const errorMessage = getErrorMessage(error);
                setErrorMessage(errorMessage);
                updateItems([], 0);
            } finally {
                updateLoading(false);
            }
        };

        fetchEmigrants();
    }, [token, state.filters]);


    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await EmigrantService.getCountries(token);
                setCountries(response.data);
            } catch (error) {
                setCountries([]);
            }
        };

        fetchCountries();
    }, [token]);


    const updateItems = (itemsList, itemsCount) => {
        const action = {
            type: "set_items",
            payload: {
                items: itemsList,
                count: itemsCount
            }
        };
        dispatch(action);
    };


    const updateLoading = (isLoading) => {
        const action = {
            type: "set_loading",
            payload: isLoading,
        };
        dispatch(action);
    };


    const refreshList = () => {
        const action = {
            type: "refresh_list",
        };
        dispatch(action);
    };


    const updateIndexVisibility = (indexVisibility) => {
        const action = {
            type: "set_index_visibility",
            payload: indexVisibility,
        };
        dispatch(action);
    };


    const onSuccess = () => {
        refreshList();
        updateIndexVisibility(0);
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SimpleHeader
                                title={"Referencat për emigrantë"}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Search
                                dispatch={dispatch}
                                countries={countries}
                                initialFilters={state.filters.searchFilters}
                                searchLoading={state.isLoading}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} align="middle" className="mt-2">
                        <Col xl={20} lg={20} md={16} sm={14} xs={14}>
                            <DataCounterCard
                                count={state.totalCount}
                                singular="referencë"
                                plural="referenca"
                            />
                        </Col>
                        <Col xl={4} lg={4} md={8} sm={10} xs={10}>
                            <Button
                                block
                                type="primary"
                                icon={<PlusOutlined />}
                                style={{ height: '37px' }}
                                onClick={() => updateIndexVisibility(1)}
                            >
                                Referencë e re
                            </Button>
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <List
                                dispatch={dispatch}
                                items={setRowNumber(state.items)}
                                totalCount={state.totalCount}
                                initialPagination={state.filters.pagination}
                                filters={state.filters}
                                isLoading={state.isLoading}
                                errorMessage={errorMessage}
                                onSuccess={onSuccess}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Add
                                countries={countries}
                                onBack={() => updateIndexVisibility(0)}
                                onSuccess={onSuccess}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 2 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Edit
                                item={state.itemSelected}
                                countries={countries}
                                onBack={() => updateIndexVisibility(0)}
                                onSuccess={onSuccess}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};


export default Emigrants;